(() => {
  if (window.cqRoPacksReady) return;
  window.cqRoPacksReady = true;

  const syncLinks = (root = document) => {
    root.querySelectorAll('[data-cq-replacement-link]').forEach((link) => {
      const input = link.closest('[data-cq-replace-card]')?.querySelector('[data-cq-replace-input]');
      if (!input?.dataset.variantId) return;
      const url = new URL(link.dataset.productUrl, location.origin);
      url.searchParams.set('variant', input.dataset.variantId);
      link.href = url.pathname + url.search;
    });
  };

  const showFit = (select) => {
    const guide = select.closest('cq-option-guide');
    const panels = [...guide.querySelectorAll('[data-cq-ro-fit-for]')];
    const sameType = panel => !guide.dataset.cqRoFitType || panel.dataset.cqRoFitType === guide.dataset.cqRoFitType;
    const sameSetup = panel => guide.dataset.cqRoFitType !== 'prefilters'
      || !guide.dataset.cqRoFitSetup || panel.dataset.cqRoFitSetup === guide.dataset.cqRoFitSetup;
    const forOutput = panels.filter(panel => panel.dataset.cqRoFitSystem === select.value && sameType(panel));
    const selected = forOutput.find(panel => panel.dataset.cqRoFitFor === guide.dataset.cqRoFitVariant)
      || forOutput.find(sameSetup);
    panels.forEach(panel => { panel.hidden = panel !== selected; });
  };

  const syncFit = (owner, variantId, selection = {}) => {
    owner?.querySelectorAll('[data-cq-ro-fit-select]').forEach((select) => {
      const guide = select.closest('cq-option-guide');
      const panels = [...guide.querySelectorAll('[data-cq-ro-fit-for]')];
      const selected = panels.find(panel => panel.dataset.cqRoFitFor === String(variantId));
      if (!selected && !selection.type) {
        panels.forEach(panel => { panel.hidden = true; });
        return;
      }
      // The same native variant can serve more than one system. The shopper's
      // configuration, when present, is authoritative for the guide's photo.
      guide.dataset.cqRoFitVariant = String(variantId ?? '');
      guide.dataset.cqRoFitType = selection.type || selected?.dataset.cqRoFitType || '';
      guide.dataset.cqRoFitSetup = selection.setup || selected?.dataset.cqRoFitSetup || '';
      const output = selection.system || selected?.dataset.cqRoFitSystem;
      select.value = [...select.options].some(option => option.value === output) ? output : select.options[0]?.value || '';
      showFit(select);
    });
  };

  // Clear the alternative before the purchase component recomputes its total.
  // Opening the individual list does not select or deselect anything.
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cq-replace-input]');
    const block = input?.closest('[data-cq-ro-replacements]');
    if (block && input.checked) {
      const complete = Boolean(input.closest('[data-cq-complete-pack]'));
      block.querySelectorAll('[data-cq-replace-input]').forEach((other) => {
        if (Boolean(other.closest('[data-cq-complete-pack]')) !== complete) other.checked = false;
      });
    }
    const select = event.target.closest('[data-cq-ro-fit-select]');
    if (select) {
      showFit(select);
      // The native fallback nests this guide in Pack; the enhanced picker docks it
      // beside System configuration. Exploration must never change purchase options.
      event.stopPropagation();
    }
    requestAnimationFrame(() => syncLinks());
  }, true);
  document.addEventListener('cq:variant-change', (event) => {
    const owner = event.target.closest('cq-purchase-options');
    const adapter = owner?.querySelector('cq-ro-pack-options');
    syncFit(owner, event.detail?.variant?.id, {
      system: adapter?.system,
      type: adapter?.pendingType || adapter?.current?.type,
      setup: adapter?.current?.type === 'prefilters' ? adapter.setup : ''
    });
    requestAnimationFrame(() => syncLinks());
  });
  document.addEventListener('cq:ro-selection-change', (event) => {
    syncFit(event.target.closest('cq-purchase-options'), event.detail?.variantId, event.detail);
  });
  document.addEventListener('shopify:section:load', (event) => syncLinks(event.target));
  syncLinks();
})();
